export default "__VITE_ASSET__D1dHKG9r__"